"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = (0, tslib_1.__importDefault)(require("react"));
const Svg_1 = (0, tslib_1.__importDefault)(require("./Svg"));
const SvgSubtract2Alt = (_a) => {
    var { size = 24 } = _a, props = (0, tslib_1.__rest)(_a, ["size"]);
    return (react_1.default.createElement(Svg_1.default, Object.assign({ fill: "currentColor", viewBox: "0 0 25 24", size: size }, props),
        react_1.default.createElement("g", { fill: "currentColor", clipPath: "url(#subtract2-alt_svg__clip0)" },
            react_1.default.createElement("path", { d: "M12.984 0c-6.609 0-12 5.39-12 12s5.391 12 12 12c6.61 0 12-5.39 12-12s-5.39-12-12-12zm0 21.984C7.454 21.984 3 17.484 3 12c0-5.531 4.5-9.984 9.984-9.984 5.532 0 9.985 4.5 9.985 9.984a9.963 9.963 0 01-9.985 9.984z" }),
            react_1.default.createElement("path", { d: "M6.36 12.012c0-.53.465-.994.995-.994h11.27c.53 0 .994.464.994.994 0 .266-.133.53-.298.697-.166.165-.431.298-.697.298H7.356a1.02 1.02 0 01-.994-.995z" })),
        react_1.default.createElement("defs", null,
            react_1.default.createElement("clipPath", { id: "subtract2-alt_svg__clip0" },
                react_1.default.createElement("path", { fill: "currentColor", d: "M0 0h24v24H0z", transform: "translate(.984)" })))));
};
exports.default = SvgSubtract2Alt;
//# sourceMappingURL=Subtract2Alt.js.map